import React, {Component} from 'react'
import { Field } from 'redux-form'
import { Trans } from "react-i18next";

const TextComp =  ({input, type, placeholder, className, onChange, meta: {error, touched}}) => {

    return <React.Fragment>
	<input {...input} placeholder={placeholder} className={[className != null ? className : 'form-control', (error && touched ? 'is-invalid' : '')].join(" ")} type={type ? type : 'text'}/>
	{touched && Array.isArray(error) && error.map(e => <small className="text-danger" key={typeof(e) === 'string' ? error : e.code}><i><Trans values={e}>validations.{typeof(e) === 'string' ? `${error}` : e.code }</Trans></i></small>)}
    </React.Fragment>
}

const InputField = (props) =>  <Field {...props} component={TextComp} />


export default InputField
